<template>
<main id="main" class="main" role="main">
    <Breadcrumb :is_h1="site_data.pagetype != 'ProductPage'" />
    <div class="section">
        <div class="container">
            <div class="columns">
                <aside class="column is-3" v-if="show_sidebar">
                    <div id="store-info-sidebar" class="menu" v-if="site_data.store">
                        <h2 class="menu-label">Store Information</h2>
                        <ul class="menu-list">
                            <li v-if="site_data.store.address">
                                <span class="icon"><i class="fas fa-map-marker-alt"></i></span> <p v-html="site_data.store.address"></p>
                            </li>
                            <li v-if="site_data.store.phone">
                                <span class="icon"><i class="fas fa-phone"></i></span> Call us: <br /><a :href="'tel:' + site_data.store.phone">{{site_data.store.phone}}</a>
                            </li>
                        </ul>
                    </div>
                    <ProductSideMenu v-if="site_data.related_categories" :title="sidebar_title" :menu="site_data.related_categories.list" :upper="site_data.related_categories.upper" />
                    <ProductPriceRanger v-if="site_data.price_ranges" :ranges="site_data.price_ranges" />
                    <router-link :title="site_data.new_offer.title" class="special-offer-item" v-if="site_data.new_offer" :to="site_data.new_offer.link">
                        <img :src="site_data.new_offer.thumb.url" />
                        <span class="special-offer-item__label">{{site_data.new_offer.label}}</span>
                    </router-link>
                    <ProductTopSellers v-if="site_data.top_sellers && site_data.top_sellers.list.length > 0" :items="site_data.top_sellers.list" :title="site_data.top_sellers.title" :url="site_data.top_sellers.url" />
                </aside>
                <ProductPage class="column is-9" v-if="site_data.pagetype == 'ProductPage'" />
                <div class="column is-9" v-if="site_data && (site_data.pagetype == 'ProductCollection' || site_data.pagetype == 'Catalog')">
                    <div class="content" v-if="site_data.content" v-html="site_data.content"></div>
                    <ProductList />
                </div>
                <div class="column is-9" v-if="is_generic_page">
                    <template v-if="site_data.pagetype != 'ContactPage'">
                        <div class="generic-page-content content bg-bkg-grey" v-if="site_data.content" v-html="site_data.content"></div>
                    </template>
                    <div class="generic-page-content bg-bkg-grey">
                        <div class="map-holder" v-if="site_data.map">
                            <GmapMap ref="mapRef" :center="{lat:site_data.map.lat.toFloat(), lng:site_data.map.lng.toFloat()}" :zoom="site_data.map.zoom.toFloat()" map-type-id="roadmap">
                                <GmapMarker v-if="site_data.map.url" :position="{lat:site_data.map.lat.toFloat(), lng:site_data.map.lng.toFloat()}" :clickable="true" @click="open_marker(site_data.map.url)" />
                            </GmapMap>
                        </div>
                        <div class="content" v-if="site_data.content" v-html="site_data.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
</template>

<script>
import ProductPage from './ProductPage';
import Breadcrumb from '../blocks/Breadcrumb';
import ProductSideMenu from '../blocks/ProductSideMenu';
import ProductList from '../blocks/ProductList';
import ProductTopSellers from '../blocks/ProductTopSellers';
import ProductPriceRanger from '../blocks/ProductPriceRanger';
export default {
    name        :   'Page',
    components  :   {
        ProductPage,
        Breadcrumb,
        ProductSideMenu,
        ProductList,
        ProductTopSellers,
        ProductPriceRanger
    },
    computed    :   {
        site_data()
        {
            return this.$store.state.site_data;
        },
        is_generic_page()
        {
            if (this.$store.state.site_data) {
                return  this.$store.state.site_data.pagetype !=  'ProductPage' &&
                        this.$store.state.site_data.pagetype !=  'Homepage' &&
                        this.$store.state.site_data.pagetype !=  'ProductCollection' &&
                        this.$store.state.site_data.pagetype !=  'Catalog';
            }

            return false;
        },
        show_sidebar()
        {
            if (this.$store.state.site_data) {
                return  this.$store.state.site_data.pagetype ==  'ProductPage' ||
                        this.$store.state.site_data.pagetype ==  'SidebaredPage' ||
                        this.$store.state.site_data.pagetype ==  'ProductCollection' ||
                        this.$store.state.site_data.pagetype ==  'ContactPage' ||
                        this.$store.state.site_data.pagetype ==  'Catalog';
            }

            return false;
        },
        sidebar_title()
        {
            if (this.$store.state.site_data) {
                if (this.$store.state.site_data.pagetype == 'SidebaredPage' ||
                    this.$store.state.site_data.pagetype == 'ContactPage') {
                    return 'You might like';
                }

                if (this.$store.state.site_data.pagetype == 'ProductPage') {
                    return 'Related Categories';
                }

                return this.$store.state.site_data.title;
            }

            return null;
        }
    },
    methods     :   {
        open_marker(url) {
            let win = window.open(url, '_blank');
            win.focus();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Page.vue